import { useRef } from "react";
import ReportCustomerPointList from "./ReportCustomerPointList";

const ReportCustomerPointMain = (props) => {
  const listRef = useRef(null);

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <ReportCustomerPointList ref={listRef} />
    </div>
  );
};

export default ReportCustomerPointMain;
